import "../../../FhCheckboxInput.css";
import { computed, withDirectives, openBlock, createElementBlock, createElementVNode, mergeProps, normalizeClass, createCommentVNode, vShow } from "vue";
import checkmark from "../../../icons-internal/checkmark.mjs";
import indeterminateIcon from "../../../icons-internal/indeterminate.mjs";
import { _ as _export_sfc } from "../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _hoisted_1 = { class: "fh-checkbox-input" };
const _hoisted_2 = ["checked", "disabled", "value"];
const _hoisted_3 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ Object.assign({
  inheritAttrs: false
}, {
  __name: "FhCheckboxInput",
  props: {
    value: {
      type: [String, Boolean],
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      required: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const computedIconClasses = computed(() => {
      return ["fh-checkbox-icon", props.disabled && "fh-checkbox-icon--disabled"];
    });
    const computedCheckboxClasses = computed(() => {
      return [
        "fh-checkbox",
        !props.valid && "fh-checkbox--invalid",
        props.indeterminate && "fh-checkbox--indeterminate"
      ];
    });
    const computedIcon = computed(() => {
      return props.indeterminate ? indeterminateIcon : checkmark;
    });
    return (_ctx, _cache) => {
      return withDirectives((openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("input", mergeProps({
          type: "checkbox",
          class: computedCheckboxClasses.value,
          checked: props.checked,
          disabled: props.disabled,
          value: props.value
        }, _ctx.$attrs), null, 16, _hoisted_2),
        props.checked || props.indeterminate ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: normalizeClass(computedIconClasses.value),
          "aria-hidden": "true",
          innerHTML: computedIcon.value
        }, null, 10, _hoisted_3)) : createCommentVNode("", true)
      ], 512)), [
        [vShow, !props.hidden]
      ]);
    };
  }
});
const FhCheckboxInput = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-b2518f8c"]]);
export {
  FhCheckboxInput as default
};
//# sourceMappingURL=FhCheckboxInput.mjs.map
